import React from "react";
import { motion } from "framer-motion";
import { Navbar } from "./Navbar";

function Features() {
  const features = [
    {
      title: "AI-Powered Phrases",
      description: "Leverage AI-driven suggestions to enhance your resume with pre-written phrases and action verbs.",
      icon: "🤖",
    },
    {
      title: "Tailored Resume Suggestions",
      description: "Our platform compares your resume with the job description to provide personalized suggestions.",
      icon: "📄",
    },
    {
      title: "Keyword Optimization",
      description: "Identify missing keywords and ensure your resume matches job requirements.",
      icon: "🔑",
    },
    {
      title: "Resume Score",
      description: "Instantly assess the quality of your resume with our unique scoring system.",
      icon: "⭐",
    }
  ];

  return (
    <>
    <Navbar />
    <div className="py-6 px-6 sm:px-16">
      <div className="text-center mb-12">
        <motion.h2
          className="text-4xl font-semibold text-gray-800"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Key Features
        </motion.h2>
        <motion.p
          className="text-lg text-gray-600 mt-4"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Discover the powerful features that make our resume builder stand out.
        </motion.p>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="bg-white p-6 rounded-lg shadow-lg text-center"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              delay: index * 0.2,
              ease: "easeOut",
            }}
          >
            {/* Icon */}
            <motion.div
              className="text-4xl mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {feature.icon}
            </motion.div>

            {/* Title */}
            <motion.h3
              className="text-xl font-semibold text-gray-800 mb-2"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              {feature.title}
            </motion.h3>

            {/* Description */}
            <motion.p
              className="text-gray-600"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              {feature.description}
            </motion.p>
          </motion.div>
        ))}
      </div>
    </div>
    </>
  );
}

export default Features;
